import type {
  IStoreRankMoreCoreRankUnifiedKey,
  IPCStoreRankPlatform,
  IPCStoreRankTop,
  IStoreRankMoreTableDimensionInfos,
  IPCStoreRankSource,
} from '@/pages/intelligence/types/storeRank';

export const PC_UNIFIED_KEY: IStoreRankMoreCoreRankUnifiedKey = 'ed_id';

export const PC_PLATFORM_STEAM: IPCStoreRankPlatform = 'steam';

export const PC_PLATFORMS: IPCStoreRankPlatform[] = [PC_PLATFORM_STEAM, 'epic'];

export const PC_PLATFORMS_KEYS_MAPPING: {
  [key: string]: string;
} = {
  epic: 'epic games',
};

export const PC_PLATFORMS_NAMES_MAPPING: {
  [key in IPCStoreRankPlatform]: string;
} = {
  steam: 'Steam',
  epic: 'Epic Games',
};

export const PC_TOP_TOP_SELLERS: IPCStoreRankTop = 'top sellers';

export const PC_TOPS: IPCStoreRankTop[] = [
  PC_TOP_TOP_SELLERS,
  'top popular',
  'most played',
  'new and trending',
  'top wish lists',
];

export const PC_SOURCE_STEAM_TOP_SELLERS = 'steam top sellers';

export const PC_SOURCES = [
  PC_SOURCE_STEAM_TOP_SELLERS,
  'steam most played',
  'steam new and trending',
  'steam top wish lists',
  'epic top sellers',
  'epic top popular',
];

// Feature flag for temporarily hiding weeks and price columns
// TODO: Remove this flag and restore weeks/price columns in next release cycle
const HIDE_WEEKS_AND_PRICE_COLUMNS = true;

const ALL_PC_SOURCES_METRICS_KEYS = [
  'steam new and trending|rank',
  'steam top sellers|rank',
  'steam top sellers|weeks',
  'steam top sellers|price',
  'steam most played|rank',
  'steam most played|peak today',
  'steam most played|price',
  'steam top wish lists|rank',
  'epic top sellers|rank',
  'epic top popular|rank',
];

export const PC_SOURCES_METRICS_KEYS = HIDE_WEEKS_AND_PRICE_COLUMNS
  ? ALL_PC_SOURCES_METRICS_KEYS.filter(key => 
      !key.includes('weeks') && 
      !(key.includes('price') && key.includes('steam top sellers'))
    )
  : ALL_PC_SOURCES_METRICS_KEYS;

export const PC_STORE_RANK_TOPS_NAMES_MAPPING: {
  [key in IPCStoreRankTop]: string;
} = {
  'top sellers': 'dbi_store_rank_top_sellers',
  'most played': 'dbi_store_rank_most_played',
  'new and trending': 'dbi_store_rank_new_and_trending',
  'top wish lists': 'dbi_store_rank_top_wish_lists',
  'top popular': 'dbi_store_rank_top_popular',
};

export const PC_STORE_RANK_TOPS_MAPPING: {
  [key in IPCStoreRankPlatform]: IPCStoreRankTop[];
} = {
  steam: ['top sellers', 'most played', 'new and trending', 'top wish lists'],
  epic: ['top sellers', 'top popular'],
};

export const PC_PLATFORM_TOP_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  'steam top sellers|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'steam',
    top: 'top sellers',
    title: PC_STORE_RANK_TOPS_NAMES_MAPPING['top sellers'],
    titleContent: 'dbi_store_rank_pc_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'steam top sellers|weeks': {
    rendererType: 'TableShowDataRenderer',
    platform: 'steam',
    top: 'top sellers',
    title: 'dbi_store_rank_weeks',
    titleContent: 'dbi_store_rank_pc_top_title_tips_week',
    titleInfo: '',
    ratioShow: false,
    ratioSortable: false,
  },
  'steam top sellers|price': {
    rendererType: 'PureTextRenderer',
    platform: 'steam',
    top: 'top sellers',
    title: 'dbi_store_rank_price$',
    titleContent: 'dbi_store_rank_pc_top_title_tips_price',
    titleInfo: '',
    ratioShow: false,
    ratioSortable: false,
  },
  'steam most played|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'steam',
    top: 'most played',
    title: 'dbi_store_rank_pc_peak_today',
    titleContent: 'dbi_store_rank_pc_top_title_tips2',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'steam most played|price': {
    rendererType: 'PureTextRenderer',
    platform: 'steam',
    top: 'most played',
    title: 'dbi_store_rank_price$',
    titleContent: 'dbi_store_rank_pc_top_title_tips_price',
    titleInfo: '',
    ratioShow: false,
    ratioSortable: false,
  },
  'steam new and trending|rank': {
    rendererType: 'TableShowDataRenderer',
    widthEN: 220,
    widthCN: 180,
    platform: 'steam',
    top: 'new and trending',
    title: 'dbi_store_rank_new_and_trending',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'steam top wish lists|rank': {
    rendererType: 'TableShowDataRenderer',
    widthEN: 186,
    widthCN: 180,
    platform: 'steam',
    top: 'top wish lists',
    title: 'dbi_store_rank_top_wish_lists',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'epic top sellers|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'epic',
    top: 'top sellers',
    title: PC_STORE_RANK_TOPS_NAMES_MAPPING['top sellers'],
    titleContent: 'dbi_store_rank_pc_top_title_tips3',
    titleInfo: 'dbi_store_rank_pc_top_title_info1',
    ratioShow: true,
    ratioSortable: false,
  },
  'epic top popular|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'epic',
    top: 'top popular',
    title: PC_STORE_RANK_TOPS_NAMES_MAPPING['top popular'],
    titleContent: 'dbi_store_rank_pc_top_title_tips4',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
};

// pc榜单下钻页 页面打点配置
export const PC_PAGE_LOG_CFG_KEYS: { [key: string]: string } = {
  'steam top sellers': 'pcStoreRankMoreSteamTopSellers',
  'steam most played': 'pcStoreRankMoreSteamMostPlayed',
  'steam new and trending': 'pcStoreRankMoreSteamNewAndTrending',
  'steam top wish lists': 'pcStoreRankMoreSteamTopWishLists',
  'epic top sellers': 'pcStoreRankMoreEpicTopSellers',
  'epic top popular': 'pcStoreRankMoreEpicTopPopular',
};

export const PC_SORT_TOPS_KEYS: {
  [key: string]: IPCStoreRankSource[];
} = {
  daily_steam: ['steam top sellers', 'steam top wish lists', 'steam most played', 'steam new and trending'],
  weekly_steam: ['steam top sellers', 'steam top wish lists', 'steam most played', 'steam new and trending'],
  daily_epic: ['epic top sellers', 'epic top popular'],
};
